(() => {
  const coverNames = {
    'chair-cover': 'Gray patio chair covers',
    'black-chair-cover': 'Black patio chair covers',
    'sofa-cover': 'Patio sofa covers',
    'ac-cover': 'Central air conditioner covers',
    'window-cover': 'Window air conditioner covers',
  };
  const key = new URLSearchParams(window.location.search).get('cover');
  const field = document.querySelector('#BL-ContactCover');
  // Only known cover identifiers may populate the inquiry; arbitrary URL text is ignored.
  if (!field || !Object.hasOwn(coverNames, key)) return;
  field.value = coverNames[key];
  field.disabled = false;
  field.closest('[data-cover-topic]').hidden = false;
})();
